module.exports = __webpack_public_path__ + "static/Column-Bands-b772dbb1f27a916c8b8dbad0c131dd71.png";